import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "../pages/Home/homeSlice";
import memoryGameReducer from "../pages/MemoryGame/memoryGameSlice";
import corporateArtCollectionsReducer from "../pages/CorporateArtCollections/corporateArtCollectionsSlice";

import locationSurveyReducer from "../pages/LocationSurvey/locationSurveySlice";

export default configureStore({
    reducer: {
        home: homeReducer,
        memoryGame: memoryGameReducer,
        corporateArtCollections: corporateArtCollectionsReducer,
    },
});
